import React, { useState, useRef } from 'react'

import _ from 'lodash'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import AuthService from '../../../business-api/AuthService'

import {
    FormikPadrao,
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivBodyEntradaDados,
    CardGridDividerElementos,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem2,
    GridItem3,
    GridItem3xs12,
    GridItem4,
    GridItem4xs12,
    GridItem5xs12,
    GridItem6,
    GridItem9,
    GridItem10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TextValidatorText,
    TextValidatorValor,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadrao,
    DatePickerPadrao,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    arrayDataToData,
} from '../../../business-components/Date/Date'

import {
    ButtonSubmit
} from '../../../business-components/Button/Button'

import {
    LinkPadraoSubmit,
} from '../../../business-components/Link/Link'

import {
    WhatsApp
} from '../../../business-components/WhatsApp/WhatsApp'

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import statusAporteList from '../../../business-rules/List/statusAporteList'

import {
    ButtonPadraoDashboardAporte,
} from '../../dashboard/dashboard-cliente-form/DashboardClienteComp'

import {
    redirecionaAportePageClienteList,
} from '../../dashboard/dashboard-cliente-form/DashboardServiceAgenda'

import {
    getAporteList,
    putAporteList,
} from './AcompanhamentoServicesAportes'



const AcompanhamentoFormAportes = ({ variaveisGlobais, valuesClienteNull, handleSubmitAutomaticoNull, dataPrevistaAporteNull, naoExibirFiltros,
    exibirLinkDashboardAporte }) => {

    const [initialValues, setInitialValues] = useState(null)

    const [carregou, setCarregou] = useState(false)
    
    const aporte = useRef(null)

    const valuesAnt = useRef(null)



    const [exibirStatusAportePendente, setExibirStatusAportePendente] =
        useState(dataPrevistaAporteNull ? true : AuthService.obterExibirStatusAportePendente(variaveisGlobais))

    const [exibirStatusAporteNaoRealizado, setExibirStatusAporteNaoRealizado] =
        useState(dataPrevistaAporteNull ? false : AuthService.obterExibirStatusAporteNaoRealizado(variaveisGlobais))

    const [exibirStatusAporteRealizado, setExibirStatusAporteRealizado] =
        useState(dataPrevistaAporteNull ? false : AuthService.obterExibirStatusAporteRealizado(variaveisGlobais))

    const handleChangeExibirStatusAportePendente = () => {

        setExibirStatusAportePendente(!exibirStatusAportePendente)

        AuthService.setarExibirStatusAportePendente(variaveisGlobais, !exibirStatusAportePendente)
    }

    const handleChangeExibirStatusAporteNaoRealizado = () => {

        setExibirStatusAporteNaoRealizado(!exibirStatusAporteNaoRealizado)

        AuthService.setarExibirStatusAporteNaoRealizado(variaveisGlobais, !exibirStatusAporteNaoRealizado)
    }

    const handleChangeExibirStatusAporteRealizado = () => {

        setExibirStatusAporteRealizado(!exibirStatusAporteRealizado)

        AuthService.setarExibirStatusAporteRealizado(variaveisGlobais, !exibirStatusAporteRealizado)
    }



    const atribuibuiInitialValues = () => {

        setInitialValues({...aporte.current})

        valuesAnt.current = {...aporte.current}
    }

    const obterAporte = async () => {

        if (valuesClienteNull) {

            await handleSubmitAutomaticoNull(valuesClienteNull)
        }

        const aporteList = await getAporteList(variaveisGlobais, valuesClienteNull ? valuesClienteNull.id : null, dataPrevistaAporteNull)

        aporte.current.aporteList = aporteList

        atribuibuiInitialValues()

        setCarregou(true)
    }
    
    useSingleton(() => {

        aporte.current = {
            aporteList: [],
        }

        if (!AuthService.usuarioPrecisaLogarNovamente(variaveisGlobais)) {

            obterAporte()

            if (exibirLinkDashboardAporte) {
                
                setExibirStatusAportePendente(true)
                setExibirStatusAporteNaoRealizado(true)
                setExibirStatusAporteRealizado(true)
            }
            
        } else {

            atribuibuiInitialValues()

            setCarregou(true)
        }
    })

    const handleSubmit = async ( values, isSubmitting ) => {

        const aporteListAux = []

        values.aporteList?.forEach((item, ind) => {

            if (
                    item.statusAporteAnt !== item.statusAporte ||
                    (
                        item.valorAporteRealizadoAnt !== item.valorAporteRealizado &&
                        (
                            item.valorAporteRealizadoAnt !== null ||
                            item.valorAporteRealizado !== ''
                        )
                    ) ||
                    item.dataRealizacaoAporteAnt !== item.dataRealizacaoAporte
            ) {

                aporteListAux.push(
                    {
                        id: item.id,
                        idAporteControle: item.idAporteControle,
                        idCliente: item.idCliente,
                        idUsuario: item.idUsuario,
                        valorAportePrevisto: item.valorAportePrevisto,
                        dataPrevistaAporte: item.dataPrevistaAporte,
                        statusAporte: item.statusAporte,
                        valorAporteRealizado: item.valorAporteRealizado,
                        dataRealizacaoAporte: item.dataRealizacaoAporte,
                    }
                )

            }
        })

        const status = await putAporteList(variaveisGlobais, aporteListAux)

        if (status) {
            
            valuesAnt.current = {...values}
        }
    }

    const GridItemIdentificacao = valuesClienteNull ? GridItem6 : GridItem4



    return (

        carregou
            ?
                <DivForm>
                    <FormikPadrao
                        initialValues={initialValues}
                        onSubmit={handleSubmit}
                        validateOnChange={false} // implementado para resolver o problema de perfomance da digitação
                        validateOnBlur={false} // implementado para resolver o problema de perfomance da digitação
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            setSubmitting,
                            setFieldValue,
                        }) => (
                            <ValidatorFormPadrao
                                onSubmit={handleSubmit}
                                onError={
                                    () => null
                                }
                            >
                                <GridContainer
                                    className="justify-center"
                                >
                                    <GridItem12>
                                        <GridContainer>
                                            <GridItem9
                                                align='right'
                                            >
                                                {exibirLinkDashboardAporte && (
                                                    <ButtonPadraoDashboardAporte
                                                        className='mt-2'
                                                    />
                                                )}
                                            </GridItem9>

                                            <GridItem3>
                                                <ButtonSubmit
                                                    align="right"
                                                    onClick={handleSubmit}
                                                    disabled={_.isEqual(values, valuesAnt.current)}
                                                />
                                            </GridItem3>
                                        </GridContainer>
                                    </GridItem12>

                                    <GridItem12>
                                        <FieldArray name="aporte">
                                            {(arrayHelpers) => (
                                                <CardGridEntradaDados>
                                                    {!naoExibirFiltros && (
                                                        <CardGridDivHeaderEntradaDados>
                                                            <GridContainer>
                                                                <GridItem12>
                                                                    <GridContainer>
                                                                        <GridItem4xs12
                                                                            className='mt--1 mb--3'
                                                                            align='center'
                                                                        >
                                                                            <CheckboxPadrao
                                                                                name='exibirStatusAportePendente'
                                                                                label={LABEL.exibirStatusAportePendente}
                                                                                checked={exibirStatusAportePendente}
                                                                                onChange={handleChangeExibirStatusAportePendente}
                                                                            />
                                                                        </GridItem4xs12>

                                                                        <GridItem4xs12
                                                                            className='mt--1 mb--3'
                                                                            align='center'
                                                                        >
                                                                            <CheckboxPadrao
                                                                                name='exibirStatusAporteNaoRealizado'
                                                                                label={LABEL.exibirStatusAporteNaoRealizado}
                                                                                checked={exibirStatusAporteNaoRealizado}
                                                                                onChange={handleChangeExibirStatusAporteNaoRealizado}
                                                                            />
                                                                        </GridItem4xs12>

                                                                        <GridItem4xs12
                                                                            className='mt--1 mb--3'
                                                                            align='center'
                                                                        >
                                                                            <CheckboxPadrao
                                                                                name='exibirStatusAporteRealizado'
                                                                                label={LABEL.exibirStatusAporteRealizado}
                                                                                checked={exibirStatusAporteRealizado}
                                                                                onChange={handleChangeExibirStatusAporteRealizado}
                                                                            />
                                                                        </GridItem4xs12>
                                                                    </GridContainer>
                                                                </GridItem12>
                                                            </GridContainer>
                                                        </CardGridDivHeaderEntradaDados>
                                                    )}

                                                    <CardGridDivBodyEntradaDados>
                                                        {values.aporteList.length > 0
                                                            ?
                                                                <DivForm
                                                                    className='mt-2'
                                                                >
                                                                    {values.aporteList?.map((item, ind) => {
                                                                        
                                                                        if (!item.statusAporteAnt) {

                                                                            item.statusAporteAnt = item.statusAporte
                                                                            item.valorAporteRealizadoAnt = item.valorAporteRealizado
                                                                            item.dataRealizacaoAporteAnt = item.dataRealizacaoAporte
                                                                        }

                                                                        if (item.statusAporte !== HARDCODE.idStatusAporteRealizado) {

                                                                            item.valorAporteRealizado = ''
                                                                            item.dataRealizacaoAporte = null

                                                                        } else {

                                                                            if (
                                                                                    !item.atribuiuRealizacao &&
                                                                                    !item.valorAporteRealizado &&
                                                                                    !item.dataRealizacaoAporte
                                                                            ) {

                                                                                item.valorAporteRealizado = item.valorAportePrevisto
                                                                                item.dataRealizacaoAporte = item.dataPrevistaAporte
                                                                            }

                                                                            item.atribuiuRealizacao = true
                                                                        }

                                                                        return (
                                                                            (
                                                                                item.statusAporteAnt === HARDCODE.idStatusAportePendente &&
                                                                                exibirStatusAportePendente
                                                                            ) ||
                                                                            (
                                                                                item.statusAporteAnt === HARDCODE.idStatusAporteNaoRealizado &&
                                                                                exibirStatusAporteNaoRealizado
                                                                            ) ||
                                                                            (
                                                                                item.statusAporteAnt === HARDCODE.idStatusAporteRealizado &&
                                                                                exibirStatusAporteRealizado
                                                                            )
                                                                        ) && (
                                                                            <GridContainer
                                                                                key={ind}
                                                                            >
                                                                                <GridItem12>
                                                                                    <GridContainer>
                                                                                        <GridItem5xs12>
                                                                                            <GridContainer>
                                                                                                {!valuesClienteNull && (
                                                                                                    <GridItemIdentificacao>
                                                                                                        <GridContainer>
                                                                                                            <GridItem2
                                                                                                                className='mt-3'
                                                                                                            >
                                                                                                                {item.celularCliente && (
                                                                                                                    <WhatsApp
                                                                                                                        numero={item.celularCliente}
                                                                                                                    />
                                                                                                                )}
                                                                                                            </GridItem2>

                                                                                                            <GridItem10
                                                                                                                className='mt-3'
                                                                                                            >
                                                                                                                <LinkPadraoSubmit
                                                                                                                    onClick={
                                                                                                                        () => redirecionaAportePageClienteList(
                                                                                                                            variaveisGlobais, item)
                                                                                                                    }
                                                                                                                    title={
                                                                                                                        <div
                                                                                                                            align='left'
                                                                                                                        >
                                                                                                                            {item.nomeSobrenomeCliente}
                                                                                                                        </div>}
                                                                                                                />
                                                                                                            </GridItem10>
                                                                                                        </GridContainer>
                                                                                                    </GridItemIdentificacao>
                                                                                                )}

                                                                                                <GridItemIdentificacao>
                                                                                                    <TextValidatorText
                                                                                                        name={`aporteList[${ind}].nomeCurtoFamiliar`}
                                                                                                        label={LABEL.familiar}
                                                                                                        value={item.nomeCurtoFamiliar || ''}
                                                                                                        onChange={handleChange}
                                                                                                        tamMax={TAMMAX.nomeCurto}
                                                                                                        disabled={true}
                                                                                                        notToUpperCase={true}
                                                                                                    />
                                                                                                </GridItemIdentificacao>

                                                                                                <GridItemIdentificacao>
                                                                                                    <TextValidatorText
                                                                                                        name={`aporteList[${ind}].descricaoTipoOrigemAporte`}
                                                                                                        label={
                                                                                                            item.origemAporte ===
                                                                                                                HARDCODE.aporteProjetoVidaSonho
                                                                                                                    ?
                                                                                                                        LABEL.tipoProjetoVidaSonho
                                                                                                                    :
                                                                                                                        LABEL.tipoRecursoFinanceiro
                                                                                                        }
                                                                                                        value={item.descricaoTipoOrigemAporte || ''}
                                                                                                        onChange={handleChange}
                                                                                                        tamMax={TAMMAX.descricao}
                                                                                                        disabled={true}
                                                                                                        notToUpperCase={true}
                                                                                                    />
                                                                                                </GridItemIdentificacao>
                                                                                            </GridContainer>
                                                                                        </GridItem5xs12>

                                                                                        <GridItem3xs12>
                                                                                            <GridContainer>
                                                                                                <GridItem6>
                                                                                                    <TextValidatorValor
                                                                                                        name={`aporteList[${ind}].valorAportePrevisto`}
                                                                                                        label={LABEL.valorAportePrevisto}
                                                                                                        value={item.valorAportePrevisto || ''}
                                                                                                        onChange={handleChange}
                                                                                                        disabled={true}
                                                                                                    />
                                                                                                </GridItem6>

                                                                                                <GridItem6>
                                                                                                    <MuiPickersUtilsProviderPadrao>
                                                                                                        <DatePickerPadrao
                                                                                                            name={`aporteList[${ind}].dataPrevistaAporte`}
                                                                                                            label={LABEL.dataPrevistaAporte}
                                                                                                            value={arrayDataToData(item.dataPrevistaAporte)}
                                                                                                            //onChange={(date) =>
                                                                                                            //    setFieldValue(
                                                                                                            //        `aporteList[${ind}].dataPrevistaAporte`,
                                                                                                            //        date
                                                                                                            //    )
                                                                                                            //}
                                                                                                            disabled={true}
                                                                                                        />
                                                                                                    </MuiPickersUtilsProviderPadrao>
                                                                                                </GridItem6>
                                                                                            </GridContainer>
                                                                                        </GridItem3xs12>

                                                                                        <GridItem4xs12>
                                                                                            <GridContainer>
                                                                                                <GridItem4>
                                                                                                    <TextFieldTextSelect
                                                                                                        name={`aporteList[${ind}].statusAporte`}
                                                                                                        label={LABEL.statusAporte}
                                                                                                        value={item.statusAporte || ''}
                                                                                                        onChange={handleChange}
                                                                                                        list={statusAporteList}
                                                                                                        corDestaque={pesquisaList(statusAporteList, item.statusAporte).corDestaque}
                                                                                                    />
                                                                                                </GridItem4>

                                                                                                <GridItem4>
                                                                                                    <TextValidatorValor
                                                                                                        name={`aporteList[${ind}].valorAporteRealizado`}
                                                                                                        label={LABEL.valorAporteRealizado}
                                                                                                        value={item.valorAporteRealizado || ''}
                                                                                                        onChange={handleChange}
                                                                                                        disabled={
                                                                                                            item.statusAporte !==
                                                                                                                HARDCODE.idStatusAporteRealizado
                                                                                                        }
                                                                                                    />
                                                                                                </GridItem4>

                                                                                                <GridItem4>
                                                                                                    <MuiPickersUtilsProviderPadrao>
                                                                                                        <KeyboardDatePickerPadrao
                                                                                                            name={`aporteList[${ind}].dataRealizacaoAporte`}
                                                                                                            label={LABEL.dataRealizacaoAporte}
                                                                                                            value={item.dataRealizacaoAporte}
                                                                                                            onChange={(date) =>
                                                                                                                setFieldValue(
                                                                                                                    `aporteList[${ind}].dataRealizacaoAporte`,
                                                                                                                    date
                                                                                                                )
                                                                                                            }
                                                                                                            disabled={
                                                                                                                item.statusAporte !==
                                                                                                                    HARDCODE.idStatusAporteRealizado
                                                                                                            }
                                                                                                        />
                                                                                                    </MuiPickersUtilsProviderPadrao>
                                                                                                </GridItem4>
                                                                                            </GridContainer>
                                                                                        </GridItem4xs12>
                                                                                    </GridContainer>

                                                                                    <CardGridDividerElementos/>
                                                                                </GridItem12>
                                                                            </GridContainer>
                                                                        )
                                                                    })}
                                                                </DivForm>
                                                            :
                                                                <div
                                                                    className='mt-4 mb-4'
                                                                >
                                                                    <h5>
                                                                        {MESSAGE().orientacaoUtilizacaoAportes}
                                                                    </h5>
                                                                </div>
                                                        }
                                                    </CardGridDivBodyEntradaDados>
                                                </CardGridEntradaDados>
                                            )}
                                        </FieldArray>
                                    </GridItem12>
                                </GridContainer>
                            </ValidatorFormPadrao>
                        )}
                    </FormikPadrao>
                </DivForm>
            :
                ''
    )
}

export default AcompanhamentoFormAportes
